import type { NonEmptyArray } from "@suse-o11y/non-empty-array";

export function generateVariableNames(name: string): NonEmptyArray<string> {
	return [name, `vars.${name}`];
}
